export default [
    {
        name: 'healthCheckStatus',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Health',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'vmsTags.name',
        hideLabel: true,
        component: {
            type: 'v-autocomplete',
            props: {
                label: 'Tags',
                dense: true,
                clearable: true,
                smallChips: true,
                deletableChips: true,
                multiple: true,
                hideSelected: true,
                itemText: 'name',
                itemValue: 'name'
            }
        }
    },
    {
        name: 'hasServiceAccount',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Has service account',
                dense: true,
                clearable: true,
                items: [
                    { text: 'Has service account', value: true },
                    { text: 'No service account', value: false }
                ]
            }
        }
    }
];
